export default __webpack_public_path__ + "static/media/logo.467073c9.svg";